import {settleExistingSection} from '../../core/actionHighlighter';
import {dispatchAcknowledgedEvent} from '../../core/resourceEvents';
import {
	USER_FILTER_EVENT,
	USER_FOCUS_EVENT,
} from './events';

/**
 * Open the Users list on Canvas Settings.
 *
 * Only the tab is closed. Canvas Settings puts Roles and Users on one
 * tab with both tables rendered together, so there is nothing further to
 * expand once the tab is selected.
 *
 * @return {Promise<void>} completion
 */
export async function openUsersSection() {
	// One level, not two. User Management renders the Roles and Users
	// tables together with plain text headings - checked in the rendered
	// page, where the tab has no accordions at all and no control answers
	// to "Users". Selecting the tab is the whole of opening this section.
	//
	// Settled rather than clicked once: this runs the moment the page is
	// navigated to, when the tabs are often not in the DOM yet, and the
	// Add User form that opens next lives inside this tab.
	try {
		return await settleExistingSection('User Management');
	} catch (_) {
		throw new Error('user_section_unavailable');
	}
}

/**
 * Filter the Users table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyUserFilter(query) {
	return dispatchAcknowledgedEvent(USER_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'user',
	});
}

/**
 * Point at one user's row in the table.
 * @param {string} entityId user identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusUser(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_user_focus'));
	return dispatchAcknowledgedEvent(USER_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'user',
	});
}
